import { initComponent } from './core/init-component';
import { fitText } from './utils/fit-text';

initComponent('.js-justify-text', (snippet) => {
  fitText(snippet);
});
